import { AddProduct } from "../events/AddProduct"

export const NewSchoolTripPage = () => {
  return <AddProduct type="wycieczka-szkolna" />
}
